<template>
  <div class="footer-box">
    <div class="app-content">
      <div class="flex-sp" style="padding-right: 100px;box-sizing: border-box;padding-bottom: 30px;border-bottom: 1px solid rgba(255, 255, 255, 0.34);">
        <ul>
          <li><router-link to="/solution">解决方案</router-link></li>
          <li><router-link to="/solution?index=index1"><a>行业挑战</a></router-link></li>
          <li><router-link to="/solution?index=index2"><a>方案优势</a></router-link></li>
          <li><router-link to="/solution?index=index3"><a>方案价值</a></router-link></li>
        </ul>
        <ul>
          <li><router-link to="/product">产品与服务</router-link></li>
          <li><router-link to="/product?index=1">预应力工程全数量检测系统</router-link></li>
          <li><router-link to="/product?index=2">锚下预应力检测系统</router-link></li>
          <li><router-link to="/product?index=3">预应力锚索基础试验系统</router-link></li>
          <li><router-link to="/product?index=4">智能拉拔系统</router-link></li>
          <li><router-link to="/product?index=5">远程监测系统</router-link></li>
        </ul>
        <ul>
          <li><router-link to="/case">典型案例</router-link></li>
          <li><router-link to="/case?index=4">高速公路</router-link></li>
          <li><router-link to="/case?index=1">软岩隧道</router-link></li>
          <li><router-link to="/case?index=2">铁路桥梁</router-link></li>
          <li><router-link to="/case?index=3">特殊桥梁</router-link></li>
          <li><router-link to="/case?index=5">边坡工程</router-link></li>
          <li><router-link to="/case?index=6">基坑工程</router-link></li>
        </ul>
<!--        <ul>-->
<!--          <li>用户服务</li>-->
<!--          <li><a>下载中心</a></li>-->
<!--          <li><a>监控平台</a></li>-->
<!--        </ul>-->
        <ul>
          <li><router-link to="/inRegard">关于我们</router-link></li>
          <li><router-link to="/inRegard">关于交达</router-link></li>
          <li><router-link to="/dataCenter">技术支持</router-link></li>
        </ul>
        <ul>
          <li><router-link to="/inRegard">联系我们</router-link></li>
          <li><router-link to="/inRegard">联系我们</router-link></li>
          <li><router-link to="/joinUs">加入我们</router-link></li>
        </ul>
      </div>

      <div class="flex-sp" style="box-sizing: border-box;padding-top: 96px">
          <div class="company-box">
             <span class="c1">联系我们</span>
            <span class="c2">023-6229-6708</span>
            <span class="c3">Copyright ©JDST 2022. All rights reserved
              <a style="margin-left: 20px" href="https://beian.miit.gov.cn" target="_blank">蜀ICP备2020033111号-1</a>
              <a  style="margin-left: 20px" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002005080" target="_blank">
                <img src="@/assets/imgs/common/hui.png" style="margin-right: 10px;height: 16px;" />公安备案号51019002005080</a></span>

          </div>

        <div class="footer-logo">
          <img class="img1" src="@/assets/imgs/common/1.png" />
          <img class="img2" src="@/assets/imgs/common/2.png" />
        </div>
      </div>


    </div>

<!--    联系我们-->

    <div class="contactUs" v-show="contactUsShow" >
      <p>留言板<i class="el-icon-d-arrow-right" @click="btn_contactUsShow(false)"></i></p>
      <el-form :model="dynamicValidateForm"  ref="ruleForm" label-width="80px"  size="mini" class="demo-dynamic">
        <el-form-item
          prop="content"
          :rules="[
         { required: true, message: '请输入您要咨询的内容', trigger: 'blur' },
      ]"
          label="内容">
          <el-input   type="textarea" :rows="4" v-model="dynamicValidateForm.content"></el-input>
        </el-form-item>
        <el-form-item
          prop="name"
          :rules="[
         { required: true, message: '请输入姓名', trigger: 'blur' },
      ]"
          label="姓名">
          <el-input v-model="dynamicValidateForm.name"></el-input>
        </el-form-item>
        <el-form-item
          prop="phone"
          :rules="[
         { required: true,trigger: 'blur',validator: checkPhone },
      ]"
          label="联系电话">
          <el-input v-model="dynamicValidateForm.phone"></el-input>
        </el-form-item>
        <el-form-item
          prop="email"
          label="邮箱">
          <el-input v-model="dynamicValidateForm.email"></el-input>
        </el-form-item>

        <el-form-item
          prop="email"
          label="地址">
          <el-input v-model="dynamicValidateForm.address"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button style="background:linear-gradient(135deg, #34E4AA 0%, #2C68FF 100%);border: 0" type="primary" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>

      </el-form>
    </div>
    <el-tooltip class="item" effect="dark" content="联系我们" placement="left-end">
    <div class="contactUss" v-show="!contactUsShow" @click="contactUsShow=true">
        <i class=" el-icon-service" style="font-size: 30px;cursor: pointer;color: #FFFFFF"></i>
    </div>
    </el-tooltip>

<!--    <el-tooltip class="item" effect="dark" content="预应力工程大数据监测与管控平台" placement="left-end">-->
<!--      <a class="contactUss1" href="http://demo.scjdst.com:8081" target="_blank">-->
<!--        <i class=" el-icon-s-platform" style="font-size: 30px;cursor: pointer;color: #FFFFFF"></i>-->
<!--      </a>-->
<!--    </el-tooltip>-->
  </div>
</template>

<script type="text/javascript">
  import eventBus from "@/assets/js/eventBus";
  import axios from "axios";
  export default {
    name: 'footers',
    data() {
      return{
        contactUsShow:true,
        dynamicValidateForm: {
          name:"",
          phone:"",
          email: '',
          address:"",
          content:""
        }
      }
    },
    mounted() {
      if(sessionStorage.getItem("contactUsShow")=="false"){
        this.contactUsShow=false
      }
    },
    created() {
      eventBus.$on("contactUsShow",(data)=>{
        this.contactUsShow = data
      })
    },
    methods:{
      checkPhone(rule, value, callback){
        const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/
        if (!value) {
          return callback(new Error('电话号码不能为空'))
        }
        setTimeout(() => {
          if (!Number.isInteger(+value)) {
            callback(new Error('请输入数字值'))
          } else {
            if (phoneReg.test(value)) {
              callback()
            } else {
              callback(new Error('电话号码格式不正确'))
            }
          }
        }, 100)
      },
      btn_contactUsShow(judge){
        this.contactUsShow=judge;
        sessionStorage.setItem("contactUsShow", judge);
      },
      submitForm(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            axios.post(this.pageUrl+`/leave-message`,this.dynamicValidateForm).then(res=>{
              this.$notify({
                type: 'success',
                title: '留言成功，感谢您的留言',
              });
            })
          } else {
            return false;
          }
        });
      }
    }
  }
  </script>

<style scoped>
  .contactUss{
    width: 60px;
    height: 60px;
    z-index: 9998;
    position: fixed;
    box-shadow: 8px 8px 30px 0px rgba(0,0,0,0.1);
    bottom: 20%;
    background: rgb(44, 104, 255);
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px 0 0 6px;
  }

  .contactUss1{
    width: 60px;
    height: 60px;
    z-index: 9997;
    text-decoration:none;
    position: fixed;
    box-shadow: 8px 8px 30px 0px rgba(0,0,0,0.1);
    bottom: 30%;
    background: rgb(44, 104, 255);
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px 0 0 6px;
  }
  .contactUs{
    position: fixed;
    bottom: 20%;
    right: 0;
    width: 300px;
    padding: 10px 10px 10px 10px;
    box-sizing: border-box;
    background: #ffffff;
    height: 400px;
    box-shadow: 8px 8px 30px 0px rgba(0,0,0,0.1);
    z-index: 9998;
    border-radius: 6px 0 0 6px;

  }
  .contactUs i{
    font-size: 20px;
    top: 15px;
    position: absolute;
    right: 0;
    cursor: pointer;
  }
  .contactUs i:hover{
    color: #2C68FF;
  }
  .demo-dynamic{
    margin-top: 20px;
    height: 340px;
    overflow: auto;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  }
  .contactUs p{
    font-size: 20px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    letter-spacing: 4px;
    text-align: center;
    color:#000000;
  }
  .footer-box{
    height: 743px;
    background: #0D0D2B;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    margin-top: 40px;
  }

  .footer-box ul{
    margin: 80px 0 0;
    color: #FFFFFF;
    padding: 0;
  }
  .footer-box ul li a{
    list-style: none;
    color: #FFFFFF;
    text-decoration: none;
  }
  .footer-box ul li:first-child{
    font-size: 16px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
  }
  .footer-box ul li:first-child:hover{
    color: #FFFFFF !important;
  }
  .footer-box ul li:hover{
    color: #2C68FF;
  }

  .footer-box ul li{
    list-style:none;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    margin-bottom: 24px;
    cursor: pointer;
  }

  .footer-box .company-box .c1{
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    display: block;
    color: #FFFFFF;
  }


  .footer-box .company-box .c2{
    font-size: 36px;
    margin-top: 34px;
    display: block;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .footer-box .company-box .c3{
    font-size: 16px;
    display: block;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #F2F2F2;
    margin-top: 56px;
  }
  .footer-box .company-box .c3 a{
    color: #ffffff;
    text-decoration:none
  }
  .footer-box .footer-logo .img1{
    width: 122px;
    display: block;
  }
  .footer-box .footer-logo .img2{
    width: 120px;
    height: 120px;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/footers.vue